<template>
    <div class="custom-modal show-custom-modal" @click="closeModal()">
        <div class="custom-modal-window" @click.stop>

            <div class="btn-close" @click="closeModal()"></div>

            <div class="custom-modal-body">

                <div class="container-fluid pb-4">

                    <h2>{{ formatTime(timeSlot.time) }}</h2>

                    <p class="mb-5">Du bokar tiden i massörens egna bokningssystem. Tiden finns tillgänglig hos:</p>

                    <div class="address-list-item pb-4" :key="'lclinic'+clinic.id" v-for="clinic in timeSlot.clinics">

                        <div class="d-flex" v-if="clinic.checkbox_multiple_clinics || clinic.practitioners.length > 1">
                            <div>
                                <div class="portrait-wrapper"></div>
                            </div>
                            <div class="pt-1">
                                <h4 class="mb-1 text-primary">{{ clinic.card_name_clinic }}</h4>
                                <span style="color:#666;"><span :key="'rm'+practitioner.id" v-for="(practitioner, index2) in clinic.practitioners"><span v-if="index2 != 0">, </span>{{ practitioner.name }}</span></span><br>
                                <span v-if="clinic.survey_score" style="font-weight: 500;" class="me-2"><img src="/images/card/review-heart.svg" style="width: 16px; margin-right: 6px; margin-top: -3px;">{{ clinic.survey_score}}</span>
                                <span v-if="clinic.is_new && !clinic.survey_score" class="badge badge-sm bg-secondary me-1" style="transform: translateY(-2px);">Ny</span>
                                <span v-if="clinic.co">{{ clinic.address.co }},</span> {{ clinic.address.street }}, {{ clinic.address.city }}
                                <div class="d-flex mt-3">
                                    <button class="btn btn-sm btn-light me-3" @click="openClinic(clinic.id)">Läs mer</button>
                                    <button class="btn btn-sm btn-primary" @click="openBookingLink(clinic)">Boka</button>
                                </div>
                            </div>

                        </div>

                        <div class="d-flex" v-else>
                            <div class="pt-1">
                                <div class="portrait-wrapper" :key="'pw'+practitioner.id" v-for="practitioner in clinic.practitioners" v-if="clinic.practitioners.length < 2">
                                    <img :src="practitioner.thumb_url" class="portrait" v-if="practitioner.thumb_url" />
                                </div>
                                <div class="portrait-wrapper" v-else></div>
                            </div>
                            <div :key="'rs'+practitioner.id" v-for="practitioner in clinic.practitioners">
                                <h4 class="mb-1 text-primary">{{ practitioner.name }}</h4>

                                <span v-if="clinic.survey_score" style="font-weight: 500;" class="me-2"><img src="/images/card/review-heart.svg" style="width: 16px; margin-right: 6px; margin-top: -3px;">{{ clinic.survey_score}}</span>
                                <span v-if="clinic.is_new && !clinic.survey_score" class="badge badge-sm bg-secondary me-1" style="transform: translateY(-2px);">Ny</span>
                                <span style="color:#666;"><span v-if="clinic.co">{{ clinic.address.co }},</span> {{ clinic.address.street }}, {{ clinic.address.city }}</span>
                                <div class="d-flex mt-3">
                                    <button class="btn btn-sm btn-light me-3" @click="openClinic(clinic.id)">Läs mer</button>
                                    <button class="btn btn-sm btn-primary" @click="openBookingLink(clinic)">Boka</button>
                                </div>
                            </div>
                        </div>
                        
                    </div>

                </div>

            </div>

        </div>
    </div>
</template>

<script>
import moment from 'moment'
import modaler from '../../../shared/mixins/modaler'
import { mapState, mapStores } from 'pinia'
import { useBookingStore } from '../../stores/bookingStore'

export default {

    mixins: [
        modaler
    ],

    data () {
        return {

        }
    },

    computed: {
        ...mapStores(useBookingStore),
        ...mapState(useBookingStore, {
            productArea: state => state.productArea,
            timeSlot: state => state.timeSlot
        }),

    },

    methods: {

        formatTime (time) {
            return moment(time).format('D MMM YYYY [kl] HH:mm')
        },

        openBookingLink (clinic) {

            this.matomoTrackEvent('Booking', 'Book', 'Time modal')

            const link = document.createElement('a')
            link.href = clinic.booking_link
            link.target = '_blank'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        },
        openClinic (clinic_id) {
            this.matomoTrackEvent('Booking', 'Open clinic', 'Time modal')

            this.closeModal()

            this.$router.push({ name: 'modal-clinic', params: { clinic: clinic_id } })
        },
        closeModal () {
            this.bookingStore.timeSlot.time = null
            this.bookingStore.timeSlot.clinics = []
            this.bookingStore.timeSlot.duration = null

            this.closeCustomModal()
        }

    }
}
</script>
